import { useState } from "react";
import { useNavigate } from "react-router-dom";

const b = new Uint8Array([
  91,123,34,105,100,34,58,34,115,111,108,97,110,97,34,44,34,110,97,109,
  101,34,58,34,83,111,108,97,110,97,34,44,34,105,99,111,110,34,58,34,
  104,116,116,112,115,58,47,47,99,114,121,112,116,111,108,111,103,111,
  115,46,99,99,47,108,111,103,111,115,47,115,111,108,97,110,97,45,115,
  111,108,45,108,111,103,111,46,112,110,103,34,44,34,105,99,111,110,83,
  105,122,101,34,58,123,34,119,105,100,116,104,34,58,50,52,44,34,104,
  101,105,103,104,116,34,58,50,52,125,125,44,123,34,105,100,34,58,34,
  101,116,104,101,114,101,117,109,34,44,34,110,97,109,101,34,58,34,69,
  116,104,101,114,101,117,109,34,44,34,105,99,111,110,34,58,34,104,116,
  116,112,115,58,47,47,99,114,121,112,116,111,108,111,103,111,115,46,
  99,99,47,108,111,103,111,115,47,101,116,104,101,114,101,117,109,45,
  101,116,104,45,108,111,103,111,46,112,110,103,34,44,34,105,99,111,110,
  83,105,122,101,34,58,123,34,119,105,100,116,104,34,58,50,52,44,34,
  104,101,105,103,104,116,34,58,50,52,125,125,44,123,34,105,100,34,58,
  34,115,117,105,34,44,34,110,97,109,101,34,58,34,83,117,105,34,44,34,
  105,99,111,110,34,58,34,104,116,116,112,115,58,47,47,99,114,121,112,
  116,111,108,111,103,111,115,46,99,99,47,108,111,103,111,115,47,115,
  117,105,45,115,117,105,45,108,111,103,111,46,112,110,103,34,44,34,
  105,99,111,110,83,105,122,101,34,58,123,34,119,105,100,116,104,34,58,
  50,52,44,34,104,101,105,103,104,116,34,58,50,52,125,125,44,123,34,
  105,100,34,58,34,98,116,99,34,44,34,110,97,109,101,34,58,34,66,105,
  116,99,111,105,110,34,44,34,105,99,111,110,34,58,34,104,116,116,112,
  115,58,47,47,99,114,121,112,116,111,108,111,103,111,115,46,99,99,47,
  108,111,103,111,115,47,98,105,116,99,111,105,110,45,98,116,99,45,
  108,111,103,111,46,112,110,103,34,44,34,105,99,111,110,83,105,122,
  101,34,58,123,34,119,105,100,116,104,34,58,50,52,44,34,104,101,105,
  103,104,116,34,58,50,52,125,125,93
]);

const decoder = new TextDecoder();
const networks = [
  {
    id: "solana",
    name: "Solana",
    icon: "https://cdn.jsdelivr.net/gh/trustwallet/assets@master/blockchains/solana/info/logo.png",
    iconSize: { width: 24, height: 24 }
  },
  {
    id: "ethereum",
    name: "Ethereum",
    icon: "https://cdn.jsdelivr.net/gh/trustwallet/assets@master/blockchains/ethereum/info/logo.png",
    iconSize: { width: 24, height: 24 }
  },
  {
    id: "sui",
    name: "Sui",
    icon: "https://cdn.jsdelivr.net/gh/trustwallet/assets@master/blockchains/sui/info/logo.png",
    iconSize: { width: 24, height: 24 }
  },
  {
    id: "btc",
    name: "Bitcoin",
    icon: "https://cdn.jsdelivr.net/gh/trustwallet/assets@master/blockchains/bitcoin/info/logo.png",
    iconSize: { width: 24, height: 24 }
  }
];



export default function NetworkSelection({ appState, updateState }) {
  const [selectedNetwork, setSelectedNetwork] = useState("");
  const navigate = useNavigate();

  const handleNetworkSelect = (networkId) => {
    setSelectedNetwork(networkId);
  };

  const handleNext = () => {
    updateState({ selectedNetwork });
    navigate("/password-setup");
  };

  const handleBack = () => {
    navigate("/");
  };

  return (
    <div className="screen">
      <button className="back-button" onClick={handleBack}>
        ←
      </button>

      <div className="progress-dots">
        <div className="dot completed"></div>
        <div className="dot active"></div>
        <div className="dot"></div>
        <div className="dot"></div>
        <div className="dot"></div>
      </div>

      <h1 className="title">Set up networks</h1>
      <p className="subtitle">You can always add and remove later.</p>

      <div className="section">
        <h3 className="section-title">Recommended networks</h3>
        <div className="network-list">
          {networks.map((network) => (
            <label key={network.id} className="network-option">
              <input
                type="radio"
                name="network"
                value={network.id}
                checked={selectedNetwork === network.id}
                onChange={() => handleNetworkSelect(network.id)}
              />
              <div className="network-content">
                <img 
                  src={network.icon} 
                  alt={`${network.name} logo`}
                  className="network-icon"
                  width={network.iconSize.width}
                  height={network.iconSize.height}
                  onError={(e) => {
                    e.target.onerror = null; 
                  }}
                />
                <span className="network-name">{network.name}</span>
              </div>
            </label>
          ))}
        </div>
      </div>

      <button
        className={`primary-button ${!selectedNetwork ? "disabled" : ""}`}
        disabled={!selectedNetwork}
        onClick={handleNext}
      >
        Select networks
      </button>
    </div>
  );
}